import React from "react";
import { CheckIcon } from "@heroicons/react/solid";

import EasyTrans from "../bundel/EasyTrans";

/**
 * Wizard progress indicator. Horizontal step list on >= lg, a compact
 * "step x / n" + progress bar below lg (the horizontal list with labels
 * overflows on tablet widths and drops the last step). Completed steps are
 * clickable to jump back.
 */
function Stepper({ steps, current, onStepClick }) {
  const pct = ((current + 1) / steps.length) * 100;

  return (
    <div>
      {/* compact (mobile + tablet) — horizontal stepper overflows below lg */}
      <div className="lg:hidden">
        <p className="text-sm font-medium text-fairblue-700">
          {current + 1} / {steps.length} —{" "}
          <EasyTrans>{steps[current].label}</EasyTrans>
        </p>
        <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full rounded-full bg-fairdarkgreen transition-all duration-300"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      {/* desktop */}
      <ol className="hidden items-center lg:flex">
        {steps.map((s, i) => {
          const completed = i < current;
          const active = i === current;
          const clickable = i < current;
          return (
            <li
              key={s.key}
              className={i < steps.length - 1 ? "flex flex-1 items-center" : "flex items-center"}
            >
              <button
                type="button"
                onClick={() => clickable && onStepClick(i)}
                disabled={!clickable}
                className={`flex items-center gap-2 ${
                  clickable ? "cursor-pointer" : "cursor-default"
                }`}
              >
                <span
                  className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                    completed
                      ? "bg-fairdarkgreen text-white"
                      : active
                        ? "bg-fairblue-500 text-white"
                        : "bg-gray-200 text-gray-500"
                  }`}
                >
                  {completed ? (
                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                  ) : (
                    i + 1
                  )}
                </span>
                <span
                  className={`whitespace-nowrap text-sm ${
                    active
                      ? "font-semibold text-fairblue-700"
                      : completed
                        ? "font-medium text-gray-700"
                        : "text-gray-400"
                  }`}
                >
                  <EasyTrans>{s.label}</EasyTrans>
                </span>
              </button>
              {i < steps.length - 1 && (
                <div
                  className={`mx-3 h-0.5 flex-1 rounded ${
                    completed ? "bg-fairdarkgreen" : "bg-gray-200"
                  }`}
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default Stepper;
